<ng-container *ngIf="!contractLoader">
    <div class="accordian-width">
        <form [formGroup]="standardBillingTemplate" *ngIf="template.standardBillingTemplate?.length">
            <p-accordion [multiple]="true" [activeIndex]="standardBillingIndex">
                <ng-container>
                    <ng-container *ngFor="let item of template.standardBillingTemplate">
                        <p-accordionTab>
                            <ng-template pTemplate="header">
                                <span>{{ item.parentLabel }}</span>
                                <span *ngIf="from =='bulk_update' && isSectionChanged('standardBillingTemplate',item.code)"
                                    class="dot">
                                </span>
                            </ng-template>
                            <div [formGroupName]="item.code">
                                <div class="row col-md-12">
                                    <ng-container *ngFor="let field of item.fields">
                                        <div *ngIf="!field?.isHide" [ngSwitch]="field.type" class="col-md-3">
                                            <div class="col-md-12 mt-3">
                                                <label *ngIf="field.type != 'checkbox'">{{field.label}}</label>
                                                <div *ngSwitchCase="'fee'">
                                                    <p-inputNumber
                                                        (onInput)="onInputFn($event.value, item.code, field.name,standardBillingTemplate)"
                                                        inputId="currency-us" mode="currency" currency="USD"
                                                        locale="en-US" [formControlName]="field.name">
                                                    </p-inputNumber>
                                                    <div
                                                        *ngIf="(standardBillingTemplate.get(item.code).get(field.name).dirty || standardBillingTemplate.get(item.code).get(field.name).touched)">
                                                        <ngb-alert [dismissible]="false" [type]="'danger'"
                                                            *ngIf="standardBillingTemplate.get(item.code).get(field.name)?.errors?.required">
                                                            {{field.validations[0].message}}
                                                        </ngb-alert>
                                                        <ngb-alert [dismissible]="false" [type]="'danger'"
                                                            *ngIf="standardBillingTemplate.get(item.code).get(field.name)?.errors?.min">
                                                            {{field.validations[1].message}}
                                                        </ngb-alert>
                                                        <ngb-alert [dismissible]="false" [type]="'danger'"
                                                            *ngIf="standardBillingTemplate.get(item.code).get(field.name)?.errors?.max">
                                                            {{field.validations[2].message}}
                                                        </ngb-alert>
                                                    </div>
                                                </div>
                                                <div *ngSwitchCase="'percent'">
                                                    <p-inputNumber id="decidedRatio"
                                                        (onInput)="onInputFn($event.value, item.code, field.name,standardBillingTemplate)"
                                                        value="#{remunerationBean.model.decidedRatio}" emptyValue="sign"
                                                        decimalPlaces="2" styleClass="field"
                                                        [formControlName]="field.name" suffix=" %"
                                                        [minFractionDigits]="2" [maxFractionDigits]="2">
                                                    </p-inputNumber>
                                                    <div
                                                        *ngIf="(standardBillingTemplate.get(item.code).get(field.name).dirty || standardBillingTemplate.get(item.code).get(field.name).touched)">
                                                        <ngb-alert [dismissible]="false" [type]="'danger'"
                                                            *ngIf="standardBillingTemplate.get(item.code).get(field.name)?.errors?.required">
                                                            {{field.validations[0].message}}
                                                        </ngb-alert>
                                                        <ngb-alert [dismissible]="false" [type]="'danger'"
                                                            *ngIf="standardBillingTemplate.get(item.code).get(field.name)?.errors?.min">
                                                            {{field.validations[1].message}}
                                                        </ngb-alert>
                                                        <ngb-alert [dismissible]="false" [type]="'danger'"
                                                            *ngIf="standardBillingTemplate.get(item.code).get(field.name)?.errors?.max">
                                                            {{field.validations[2].message}}
                                                        </ngb-alert>
                                                    </div>
                                                </div>
                                                <div *ngSwitchCase="'radio'">
                                                    <div *ngFor="let option of field.options">
                                                        <input type="radio" [formControlName]="field.name"
                                                            [value]="option.value" />
                                                        {{ option.label }}
                                                    </div>
                                                </div>
                                                <div *ngSwitchCase="'checkbox'">
                                                    <label for="checkBoxlabel"
                                                        class="pt-2">{{field.checkBoxDisplayLabel}}</label>
                                                    <div *ngSwitchCase="'checkbox'"
                                                        class="p-field-checkbox d-flex align-items-center mb-2">
                                                        <p-checkbox (onChange)="onInputFn($event.checked, item.code, field.name, standardBillingTemplate)" [formControlName]="field.name" inputId="field.name"
                                                            [binary]="true"></p-checkbox>
                                                        <label for="field.name" class="mb-0 ml-1">{{
                                                            field.label }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngSwitchDefault>Default unhandled element{{ field.type
                                                }}</div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </p-accordionTab>
                    </ng-container>

                </ng-container>

            </p-accordion>
        </form>
        <p-accordion [multiple]="true" [activeIndex]="[0]" *ngIf="template.valueAddedServiceTemplate?.length">
            <ng-container>
                <p-accordionTab>
                    <ng-template pTemplate="header">
                                <span>Value Added Services</span>
                                <span *ngIf="from =='bulk_update' && isSectionChanged('valueAddedServiceTemplate')" class="dot">
                                </span>
                            </ng-template>
                    <form [formGroup]="valueAddedServiceTemplate">

                        <ng-container *ngFor="let item of template.valueAddedServiceTemplate">
                            <p-fieldset [formGroupName]="item.code" [legend]="item.parentLabel">
                                <div class="p-3 align-margin-height">
                                    <div class="d-flex row col-md-12 my-2">
                                        <ng-container *ngFor="let field of item.fields; let j = index">
                                            <div class="col-md-3 pt-2">
                                                <label>{{ field.label }}</label>
                                                <div *ngIf="field.type == 'fee'">
                                                    <p-inputNumber
                                                        (onInput)="onInputFn($event.value, item.code, field.name,valueAddedServiceTemplate)"
                                                        inputId="currency-us" mode="currency" currency="USD"
                                                        locale="en-US" [formControlName]="field.name">
                                                    </p-inputNumber>
                                                </div>
                                                <div *ngIf="field.type == 'percent'">
                                                    <p-inputNumber id="decidedRatio"
                                                        (onInput)="onInputFn($event.value, item.code, field.name,valueAddedServiceTemplate)"
                                                        value="#{remunerationBean.model.decidedRatio}" emptyValue="sign"
                                                        decimalPlaces="2" styleClass="field"
                                                        [formControlName]="field.name" suffix=" %"
                                                        [minFractionDigits]="2" [maxFractionDigits]="2">
                                                    </p-inputNumber>
                                                </div>
                                                <div
                                                    *ngIf="(valueAddedServiceTemplate.get(item.code).get(field.name).dirty || valueAddedServiceTemplate.get(item.code).get(field.name).touched)">
                                                    <ngb-alert [dismissible]="false" [type]="'danger'"
                                                        *ngIf="valueAddedServiceTemplate.get(item.code).get(field.name)?.errors?.required">
                                                        {{field.validations[0].message}}
                                                    </ngb-alert>
                                                    <ngb-alert [dismissible]="false" [type]="'danger'"
                                                        *ngIf="valueAddedServiceTemplate.get(item.code).get(field.name)?.errors?.min">
                                                        {{field.validations[1].message}}
                                                    </ngb-alert>
                                                    <ngb-alert [dismissible]="false" [type]="'danger'"
                                                        *ngIf="valueAddedServiceTemplate.get(item.code).get(field.name)?.errors?.max">
                                                        {{field.validations[2].message}}
                                                    </ngb-alert>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </p-fieldset>
                        </ng-container>

                    </form>

                </p-accordionTab>
            </ng-container>
        </p-accordion>
    </div>
</ng-container>
<ng-container *ngIf="contractLoader">
    <app-loading> </app-loading>
</ng-container>